import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES } from '@demind-inc/core';

import enCommon from './locales/en/common.json';
import itCommon from './locales/it/common.json';
import koCommon from './locales/ko/common.json';
import elCommon from './locales/el/common.json';
import jaCommon from './locales/ja/common.json';
import frCommon from './locales/fr/common.json';
import deCommon from './locales/de/common.json';
import esCommon from './locales/es/common.json';
import ptCommon from './locales/pt/common.json';
import zhHansCommon from './locales/zh-Hans/common.json';

export const resources = {
  en: { common: enCommon },
  it: { common: itCommon },
  ko: { common: koCommon },
  el: { common: elCommon },
  ja: { common: jaCommon },
  fr: { common: frCommon },
  de: { common: deCommon },
  es: { common: esCommon },
  pt: { common: ptCommon },
  'zh-Hans': { common: zhHansCommon },
};

i18n.use(initReactI18next).init({
  resources,
  lng: DEFAULT_LANGUAGE,
  fallbackLng: DEFAULT_LANGUAGE,
  supportedLngs: [...SUPPORTED_LANGUAGES],
  defaultNS: 'common',
  ns: ['common'],
  interpolation: { escapeValue: false },
  react: { useSuspense: false },
  returnNull: false,
});

export const getCurrentI18nLanguage = () => {
  const i18nInstance = i18n as unknown as {
    language?: string;
    languages?: readonly string[];
    resolvedLanguage?: string;
  };

  return (
    i18nInstance.resolvedLanguage ??
    i18nInstance.language ??
    i18nInstance.languages?.[0] ??
    DEFAULT_LANGUAGE
  );
};

export const changeI18nLanguage = (language: string) => {
  const i18nInstance = i18n as unknown as {
    changeLanguage: (language: string) => Promise<unknown>;
  };

  return i18nInstance.changeLanguage(language);
};

export const translateI18n = (key: string, options?: Record<string, unknown>) => {
  const i18nInstance = i18n as unknown as {
    t: (key: string, options?: Record<string, unknown>) => string;
  };

  return i18nInstance.t(key, options);
};

export default i18n;
